// extracted by mini-css-extract-plugin
export default {"container":"Switcher-module__container","input":"Switcher-module__input","widget":"Switcher-module__widget"};